import { Modal, Tabs, Typography, Tag, Flex, notification } from "antd";
import AlarmTab from "./DeviceInformationModal/AlarmTab";
import TrendingTab from "./DeviceInformationModal/TrendingTab";
import GeneralTab from "./DeviceInformationModal/GeneralTab";
import PowerEnergyTab from "./DeviceInformationModal/PowerEnergyTab";
import { useContext, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { IndexContext } from "../../context/IndexContext";
const { Title, Text } = Typography;

function DeviceInformation({
  openModal,
  setOpenModal,
  deviceID,
  themeToken,
  modalData,
  siteCommissioningDate,
}) {
  const { notificationApi } = useContext(IndexContext);
  const [fetchWrapper] = useFetch();
  const [deviceGeneralInfo, setDeviceGeneralInfo] = useState(null);

  const items = [
    {
      key: "1",
      label: "General",
      children: (
        <GeneralTab
          themeToken={themeToken}
          deviceData={deviceGeneralInfo}
          deviceID={deviceID}
        />
      ),
    },
    {
      key: "2",
      label: "Power & Energy",
      children: (
        <PowerEnergyTab
          themeToken={themeToken}
          deviceData={modalData}
          deviceID={deviceID}
        />
      ),
    },
    {
      key: "3",
      label: "Alarms",
      children: (
        <AlarmTab
          themeToken={themeToken}
          tableWrapperViewportHeight={0.75}
          deviceID={deviceID}
          siteCommissioningDate={siteCommissioningDate}
        />
      ),
    },
    {
      key: "4",
      label: "Trend",
      children: (
        <TrendingTab
          themeToken={themeToken}
          deviceID={deviceID}
          deviceData={deviceGeneralInfo}
          siteCommissioningDate={siteCommissioningDate}
        />
      ),
    },
  ];

  function getDeviceGeneralInfo() {
    if (deviceID == null) return;

    fetchWrapper({
      endpoint_url: "device_monitoring/getSelectedDeviceGeneralInfo",
      method: "GET",
      params: { deviceID: deviceID },
      onSuccess: (resp) => {
        setDeviceGeneralInfo(resp.data);
      },
      onResponseError: (error) => {
        notificationApi.error({
          message: error.message,
        });
      },
    });
  }

  const handleOk = () => {
    setOpenModal(false);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    setDeviceGeneralInfo(null);
    getDeviceGeneralInfo();
  }, [deviceID]);

  return (
    <>
      <Modal
        title={
          <div>
            <Text className="mr-2">{deviceGeneralInfo?.name}</Text>
            <Tag color="#536493">
              <Text style={{ color: "white" }}>
                {deviceGeneralInfo?.deviceType}
              </Text>
            </Tag>
          </div>
        }
        open={openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose
        footer={null}
        width={"85vw"}
        style={{ maxWidth: "90vw" }}
      >
        <Tabs style={{ height: "75vh" }} items={items}></Tabs>
      </Modal>
    </>
  );
}

export default DeviceInformation;
